(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __moduleCache = /* @__PURE__ */ new WeakMap();
  var __toCommonJS = (from) => {
    var entry = __moduleCache.get(from),
      desc;
    if (entry) return entry;
    entry = __defProp({}, "__esModule", { value: true });
    if ((from && typeof from === "object") || typeof from === "function")
      __getOwnPropNames(from).map(
        (key) =>
          !__hasOwnProp.call(entry, key) &&
          __defProp(entry, key, {
            get: () => from[key],
            enumerable:
              !(desc = __getOwnPropDesc(from, key)) || desc.enumerable,
          }),
      );
    __moduleCache.set(from, entry);
    return entry;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, {
        get: all[name],
        enumerable: true,
        configurable: true,
        set: (newValue) => (all[name] = () => newValue),
      });
  };

  // assets/scripts/cart/cart-drawer.ts
  var exports_cart_drawer = {};
  __export(exports_cart_drawer, {
    CartDrawer: () => CartDrawer,
  });

  // utils/modalOverflow.ts
  var hasOpenModals = () => {
    const openMegaMenus = document.querySelectorAll(
      "header-mega-menu-content[open]",
    );
    if (openMegaMenus.length > 0) return true;
    const openSearchModal = document.querySelector("search-modal[open]");
    if (openSearchModal) return true;
    const openCartDrawer = document.querySelector(".em-cd.is-open");
    if (openCartDrawer) return true;
    return false;
  };
  var setBodyOverflow = (value) => {
    if (value === "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      if (!hasOpenModals()) {
        document.body.style.overflow = "";
      }
    }
  };

  // assets/scripts/cart/cart-drawer.ts
  class CartDrawer extends HTMLElement {
    activeElement;
    open() {
      window.EmelineCartDrawer?.open();
    }
    close() {
      window.EmelineCartDrawer?.close();
    }
    setActiveElement(element) {
      this.activeElement = element;
    }
    getSectionsToRender() {
      return [
        {
          id: "cart-drawer",
          selector: ".em-cd",
        },
      ];
    }
    async renderContents(_parsedState) {
      this.open();
      try {
        const response = await fetch(
          `${window.location.origin}?section_id=cart-drawer`,
        );
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newDrawer = doc.querySelector(".em-cd");
        const currentDrawer = document.querySelector(".em-cd");
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          if (window.EmelineCartDrawer) {
            window.EmelineCartDrawer.recalc();
          }
          document.dispatchEvent(new CustomEvent("cart:updated"));
        }
      } catch (error) {
        console.error("Error updating cart:", error);
      }
    }
  }
  (() => {
    let drawer;
    let overlay;
    let lastFocus = null;
    const config = window.cartDrawerConfig || {
      freeShippingThreshold: 50000,
    };
    const FREE_SHIPPING_THRESHOLD = config.freeShippingThreshold;
    const translations = window.cartDrawerTranslations || {
      shipping_free: "Free",
      shipping_calculated: "Calculated at checkout",
      free_shipping_remaining: "__AMOUNT__ to free shipping",
      free_shipping_unlocked: "You have unlocked free shipping ✔️",
      count_one: "1 piece",
      count_other: "__COUNT__ pieces",
    };
    const qs = (sel, ctx = document) => {
      return ctx.querySelector(sel);
    };
    const qsa = (sel, ctx = document) => {
      return Array.from(ctx.querySelectorAll(sel));
    };
    const open = () => {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      if (overlay) overlay.classList.add("is-open");
      setBodyOverflow("hidden");
      recalc();
      const closeBtn = qs("[data-em-cd-close]", drawer);
      if (closeBtn) closeBtn.focus();
    };
    const close = () => {
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      if (overlay) overlay.classList.remove("is-open");
      setBodyOverflow("");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    const toggle = () => {
      if (!drawer) return;
      drawer.classList.contains("is-open") ? close() : open();
    };
    const parsePrice = (str) => {
      if (!str) return 0;
      return parseInt(String(str).replace(/[^\d]/g, ""), 10) || 0;
    };
    const formatPrice = (cents) => {
      const amount = cents / 100;
      return `${Math.round(amount)} kr`;
    };
    const recalc = () => {
      if (!drawer) return;
      const items = qsa(".em-cd__item", drawer);
      let subtotal = 0;
      items.forEach((row) => {
        const unit = parsePrice(
          row.dataset.unitPrice ||
            row.querySelector(".em-cd__item-price")?.textContent,
        );
        const qtyEl = row.querySelector(".em-cd__qty-value");
        const qty = parseInt(qtyEl?.textContent || "1", 10) || 1;
        const line = unit * qty;
        subtotal += line;
        const priceEl = row.querySelector(".em-cd__item-price");
        if (priceEl) priceEl.textContent = formatPrice(line);
      });
      const subtotalEl = qs("[data-em-cd-subtotal]", drawer);
      if (subtotalEl) subtotalEl.textContent = formatPrice(subtotal);
      const shippingEl = qs("[data-em-cd-shipping]", drawer);
      const freeShipping = subtotal >= FREE_SHIPPING_THRESHOLD;
      if (shippingEl) {
        if (subtotal === 0) {
          shippingEl.textContent = "—";
        } else if (freeShipping) {
          shippingEl.textContent = translations.shipping_free;
        } else {
          shippingEl.textContent =
            translations.shipping_calculated || "Calculated at checkout";
        }
      }
      const totalEl = qs("[data-em-cd-total]", drawer);
      if (totalEl) totalEl.textContent = formatPrice(subtotal);
      const fill = qs("[data-em-cd-shipping-fill]", drawer);
      const pct = Math.min(100, (subtotal / FREE_SHIPPING_THRESHOLD) * 100);
      if (fill) {
        fill.style.width = `${pct}%`;
      }
      const remaining = qs("[data-em-cd-shipping-remaining]", drawer);
      if (remaining) {
        const diff = FREE_SHIPPING_THRESHOLD - subtotal;
        remaining.textContent =
          diff > 0
            ? translations.free_shipping_remaining.replace(
                "__AMOUNT__",
                formatPrice(diff),
              )
            : translations.free_shipping_unlocked;
      }
      const progressLabel = qs("[data-em-cd-shipping-progress]", drawer);
      if (progressLabel) {
        progressLabel.textContent = `${formatPrice(subtotal)} / ${formatPrice(FREE_SHIPPING_THRESHOLD)}`;
        progressLabel.style.display = freeShipping ? "none" : "";
      }
      const shippingTrack = qs("[data-em-cd-shipping-track]", drawer);
      if (shippingTrack) {
        shippingTrack.style.display = freeShipping ? "none" : "";
      }
      const hasItems = items.length > 0;
      drawer.classList.toggle("is-empty", !hasItems);
      const emptyEl = qs(".em-cd__empty", drawer);
      const itemsEl = qs(".em-cd__items", drawer);
      if (emptyEl && itemsEl) {
        emptyEl.style.display = hasItems ? "none" : "flex";
        itemsEl.style.display = hasItems ? "block" : "none";
      }
      const checkoutBtn = qs(".em-cd__checkout", drawer);
      if (checkoutBtn) checkoutBtn.disabled = !hasItems;
      const countEl = qs("[data-em-cd-count]", drawer);
      if (countEl) {
        const totalQty = items.reduce((sum, row) => {
          const q =
            parseInt(
              row.querySelector(".em-cd__qty-value")?.textContent || "0",
              10,
            ) || 0;
          return sum + q;
        }, 0);
        const countText =
          totalQty === 1
            ? translations.count_one
            : translations.count_other.replace("__COUNT__", String(totalQty));
        countEl.textContent = countText;
      }
    };
    const onClick = (e) => {
      const t = e.target;
      if (!t || !drawer?.contains(t)) return;
      const addBtn = t.closest(".em-cd__cross-add");
      if (addBtn) {
        return;
      }
    };
    const init = () => {
      drawer = qs(".em-cd");
      overlay = qs(".em-cd-overlay");
      if (!drawer) return;
      qsa("[data-em-cd-open]").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          open();
        });
      });
      drawer.addEventListener("click", (e) => {
        const target = e.target;
        const closeElement = target.closest("[data-em-cd-close]");
        if (closeElement) {
          if (closeElement.tagName !== "A") {
            e.preventDefault();
          }
          close();
        }
      });
      if (overlay) overlay.addEventListener("click", close);
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && drawer?.classList.contains("is-open"))
          close();
      });
      drawer.addEventListener("click", onClick);
      recalc();
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
    window.EmelineCartDrawer = {
      open,
      close,
      toggle,
      recalc,
    };
    if (!customElements.get("cart-drawer")) {
      customElements.define("cart-drawer", CartDrawer);
    }
  })();
})();
